import { useContext } from "react";
import { Navigate } from "react-router";

import { ThemeSelectorContext } from "@/basic/context";

import { SelectPlan } from "../SelectPlan";

export const Home = () => {
  const { client } = useContext(ThemeSelectorContext);

  let mainContent: JSX.Element | null = null;

  if (client) {
    if (client === "cdphp") {
      mainContent = <SelectPlan />;
    }
  }

  return mainContent ? mainContent : <Navigate to="/404" />;
};
